import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const PhilosophySection = () => {
  const { t } = useLanguage();

  return (
    <section id="philosophy" className="section-spacing bg-background">
      <div className="container-luxury max-w-3xl mx-auto text-center">
        <motion.span
          className="font-label text-bronze block mb-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        >
          {t("The Arzani Approach", "De Arzani Aanpak")}
        </motion.span>

        <motion.h2
          className="font-display text-3xl md:text-5xl lg:text-6xl text-foreground leading-[1.1] mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          {t("Where every detail is", "Waar elk detail al")}
          <br />{t("already arranged.", "geregeld is.")}
        </motion.h2>

        <motion.div
          className="divider-subtle mx-auto mb-12"
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        />

        <motion.p
          className="font-body text-muted-foreground text-sm md:text-base leading-[1.9] max-w-xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          {t(
            "At Arzani, every service is thoughtfully curated to provide effortless access to exceptional experiences. From the moment you arrive, our team ensures that every detail — from mobility to residence and time at sea — is arranged with precision and discretion.",
            "Bij Arzani wordt elke dienst zorgvuldig samengesteld om moeiteloze toegang te bieden tot uitzonderlijke ervaringen. Vanaf het moment dat u aankomt, zorgt ons team ervoor dat elk detail — van mobiliteit tot verblijf en tijd op zee — met precisie en discretie wordt geregeld."
          )}
        </motion.p>
      </div>
    </section>
  );
};

export default PhilosophySection;
